import { useRouter } from "next/router";
import { axiosApiInstance } from "../../../pages/api/axios";
import { useMoneyHashQuery } from "../../../hooks/useMoneyHashQuery";

export interface ReportFilter extends Record<string, unknown> {
  field_name: string;
  field_type: string;
}

interface FilterOptions {
  filter_types: ReportFilter[];
}

export function useReportsFilters() {
  const router = useRouter();
  const { account, organization } = router.query;

  const { data, isLoading } = useMoneyHashQuery<FilterOptions>({
    queryKey: ["reports-filter-options", { account, organization }],
    queryFn: ({ signal }) =>
      axiosApiInstance
        .get("/d/metrics/filter_options/", {
          signal,
          params: {
            account: account || undefined,
            organization: organization || undefined,
          },
        })
        .then((res) => res.data),
  });

  return { filters: data?.filter_types ?? [], isLoading };
}
